<script>

import { ref } from 'vue'
import PuntoDeVentaDetalle from './PuntoDeVentaDetalle.vue';

const diálogoPuntoDeVenta = ref(false)
const puntoDeVentaSeleccionado = ref(null)

function abrirCreación() {
	puntoDeVentaSeleccionado.value = null
	diálogoPuntoDeVenta.value = true
}

function abrirEdición(datos) {
	diálogoPuntoDeVenta.value = true
	puntoDeVentaSeleccionado.value = datos
}

export default {
	setup() {
		return {
			puntoDeVentaSeleccionado,
			diálogoPuntoDeVenta,
			abrirCreación,
			abrirEdición,
		}
	},

	components: {
		PuntoDeVentaDetalle
	}
}

</script>

<template>
	<div>
		<router-view @editar="abrirEdición($event)"></router-view>

		<v-dialog
			v-model="diálogoPuntoDeVenta"
			max-width="900"
			persistent
		>
			<PuntoDeVentaDetalle
				:datos="puntoDeVentaSeleccionado"
				@guardar="diálogoPuntoDeVenta = false"
				@cancelar="diálogoPuntoDeVenta = false"
			></PuntoDeVentaDetalle>
		</v-dialog>

		<v-btn
			fixed
			dark
			fab
			bottom
			right
			color="pink"
			@click.stop="abrirCreación()"
		>
			<v-icon>mdi-plus</v-icon>
		</v-btn>
	</div>
</template>
